import { Injectable, TemplateRef, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HeaderActionsService {
  readonly template = signal<TemplateRef<unknown> | null>(null);

  set(template: TemplateRef<unknown>): void {
    this.template.set(template);
  }

  clear(template: TemplateRef<unknown>): void {
    if (this.template() === template) {
      this.template.set(null);
    }
  }
}
